import React from 'react';
import classNames from 'classnames';

// TODO Review use of this class by reading https://lets-do-this.atlassian.net/browse/LDS-42
import { GLOBAL_FORM_STYLES_CLASS } from '@/globalClasses';

import ErrorMessage from '../ErrorMessage';
import * as styles from './styles.module.css';
import { FieldParams, ErrorMessageParams } from '../Types';
import { validateFieldParams } from '../Validator';
import Overlay from '../Overlay';

const FirstHalf = (params: FieldParams): JSX.Element => {
  validateFieldParams(params);
  const { value, setValue, title, error, overlay } = params;
  return (
    <div className={styles.doubleField}>
      <div
        className={classNames(styles.headerText, {
          [`${styles.error}`]: !!error,
        })}
      >
        {title}
      </div>
      <input
        className={classNames(styles.firstInputField, {
          [`${styles.errorInput}`]: !!error,
        })}
        type="text"
        onChange={(event) => setValue(event.target.value)}
        value={value || ''}
      />
      {overlay && Overlay(overlay)}
    </div>
  );
};

const SecondHalf = (params: FieldParams): JSX.Element => {
  validateFieldParams(params);
  const { value, setValue, title, error, overlay } = params;
  return (
    <div className={styles.doubleField}>
      <div
        className={classNames(styles.headerText, {
          [`${styles.error}`]: !!error,
        })}
      >
        {title}
      </div>
      <input
        className={classNames(styles.secondInputField, {
          [`${styles.errorInput}`]: !!error,
        })}
        type="text"
        onChange={(event) => setValue(event.target.value)}
        value={value || ''}
      />
      {overlay && Overlay(overlay)}
    </div>
  );
};

const DoubleField = (field1: FieldParams, field2: FieldParams): JSX.Element => {
  return (
    <div
      className={classNames(styles.errorContainer, GLOBAL_FORM_STYLES_CLASS)}
    >
      <div className={styles.container}>
        {FirstHalf(field1)}
        {SecondHalf(field2)}
      </div>
      {field1.error && ErrorMessage(field1 as ErrorMessageParams)}
      {field2.error && ErrorMessage(field2 as ErrorMessageParams)}
    </div>
  );
};

export default DoubleField;
